<template>
  <div class="popUpWrap">
    <section ref="levelInfoPopup" class="popup light">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="titleArea flex">
          <h5>{{ profileAssessment.trackTitle + " - " + profileAssessment.trackLevelTitle }}</h5>
          <!-- TODO: SkillAdvance 잠정 비활성화 -->
<!--          <ul class="slashList">-->
<!--            <li>-->
<!--              <span>{{ t('advance-related-practice') }}</span>-->
<!--              <a class="relatedLink" @click.stop="onClickShiftTrackDetail(profileAssessment.trackId as number)">-->
<!--                <span></span>{{ profileAssessment.trackTitle }}-->
<!--              </a>-->
<!--            </li>-->
<!--          </ul>-->
        </div>
        <ul class="infoList flex">
          <li class="flex">
            <div class="tit">{{ t('common-skill' )}}</div>
            <ul class="boxList flex scrollY">
              <li v-for="(skill, index) in profileAssessment.competencyModelVOList" :key="index">
                {{ skill.skill }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useDialogStore } from "~~/application/store/dialog/dialogStore";
import { onClickOutside } from "@vueuse/core";
import { TrackType } from "~~/package/mapper/track/model/TrackType";
import type { ProfileUserAssessmentModel } from "~~/package/mapper/profile/model/ProfileUserAssessmentModel";

const { t } = useI18n();
const dialogStore = useDialogStore();
const router = useRouter();
const profileAssessment = ref<ProfileUserAssessmentModel>(dialogStore.options.props.assessment)
const levelInfoPopup = ref(null);

const onClickShiftTrackDetail = (trackId: number) => {
  const trackDetailRouteData = router.resolve({
    name: "dashboard-skillAdvance-practice-practiceId",
    params: { practiceId: trackId }
  });
  window.open(trackDetailRouteData.href, "_blank");
};

const onClickClose = () => {
  dialogStore.close();
};

onClickOutside(levelInfoPopup, () => {
  onClickClose();
})
</script>

